<template>
  <div class="lby-footer">
    <a href="/#/cooperation">联系我们</a>
    <a href="/#/cooperation">关于我们</a>
    <a href="/#/cooperation">商户合作</a>
    <a href="/agreements/102.html">平台协议</a>
    <a href="/agreements/101.html">隐私政策</a>
    <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">网站备案:辽ICP备2025062858号-1</a>
    <!-- <a href="#">ICP许可证:</a> -->
    <a href="#">岫岩满族自治县梦想起航网络科技有限公司</a>
  </div>
</template>

<script>
export default {
  name: 'MyFooter'
}
</script>

<style scoped lang="less">
.lby-footer{
    height: 100px;
    width: 100%;
    margin: 20px auto;
    background-color: #272727;
    margin-top: 50px;
    a{
      color: white;
      decoration:none;
      line-height: 100px;
      display: inline-block;
      margin-left: 10px;
    }
}
</style>
